import z from 'zod'

export const ZodPasswordCheck = (t: (translation: string) => string, prefix: string) =>
  z
    .string()
    .min(8, { error: t(`${prefix}.form.fields.password.error.min`) })
    .refine((password) => /[A-Z]/.test(password), {
      error: t(`${prefix}.form.fields.password.error.uppercase`),
    })
    .refine((password) => /[a-z]/.test(password), {
      error: t(`${prefix}.form.fields.password.error.lowercase`),
    })
    .refine((password) => /\d/.test(password), {
      error: t(`${prefix}.form.fields.password.error.number`),
    })
    .refine((password) => /[@!#$%&]/.test(password), {
      error: t(`${prefix}.form.fields.password.error.special-character`),
    })
